// tripData.js
export const trips = [
  {
    id: 1,
    slug: "open-trip-4d3n-fastboat",
    title: "4D3N Via Fastboat",
    route: "Ambon - Banda Neira",
    price: "IDR. 2.999.999 /orang",
    image: "/images/fastboat.png",
    description: "Trip ini cocok untuk kalian yang waktunya terbatas atau sedang mengejar cuti, tapi tetap ingin merasakan keindahan surga rempah di Banda Neira",
    notes: "SARAN PERJALANAN: Gunakan pesawat dari kota asal ke Bandara Pattimura Ambon. Kami bisa sediakan mobil penjemputan dari Bandara ke Pelabuhan/Hotel dan membantu pemesanan tiket Fastboat Tulehu/Ambon-Banda.",
    mepo: "Pelabuhan Banda Neira",
    schedule: [
      ['Oktober', '01 - 04', '2 orang'],
      ['Oktober', '08 - 11', '2 orang'],
      ['Oktober', '15 - 18', '2 orang'],
      ['Oktober', '22 - 25', '2 orang'],
      ['Oktober - November', '29 - 01', '2 orang'],
      ['November', '05 - 08', '2 orang'],
      ['November', '12 - 15', '2 orang'],
      ['November', '19 - 22', '2 orang'],
      ['November', '26 - 29', '2 orang'],
      ['Desember', '03 - 06', '2 orang'],
      ['Desember', '10 - 13', '2 orang'],
      ['Desember', '17 - 20', '2 orang'],
      ['Desember', '24 - 27', '2 orang'],
      ['Desember - Januari', '31 - 03', '2 orang'],
    ],
    // HEADER ITINERARY INFO
  itineraryNote: "Itinerary sewaktu-waktu dapat berubah menyesuaikan cuaca dan kondisi di lapangan.",
  fastboatInfo: {
    berangkat: "Keberangkatan dari Pelabuhan Tulehu Hari Kamis jam 09.00 (Tiba 14.30/15.00)",
    pulang: "Keberangkatan dari Banda Hari Minggu jam 07.00/08.00 (Tiba Tulehu 14.30/15.00)"
  },

  day1: [
    "🤝 Penjemputan di Pelabuhan Banda Neira",
    "🥤 Welcome Drink (Jus pala + Pancake pala)",
    "🏛️ Rumah Budaya & Rumah Pengasingan Sjahrir",
    "🔑 Check-in & Beberes",
    "🏠 Rumah Pengasingan Hatta & Istana Mini",
    "🏨 Balik ke Penginapan",
    "🍽️ Makan Malam",
    "✨ Aktivitas Bebas & Istirahat"
  ],
  day2: [
    "🍽️ Sarapan",
    "🚤 Hopping Island",
    "🐬 Pulau Hatta (Dolphin Area)",
    "🤿 Snorkeling",
    "🍱 Makan Siang",
    "🏝️ Pulau Sjahrir",
    "🌳 Perkebunan Pala & Tebing Seram",
    "🤿 Lava Flow (Snorkeling) & Sunset",
    "🏨 Balik ke Penginapan",
    "🍽️ Makan Malam",
    "✨ Aktivitas Bebas & Istirahat"
  ],
  day3: [
    "🍽️ Sarapan",
    "📜 Sumur Genosida",
    "🏰 Benteng Belgica",
    "🛍️ Belanja Oleh-oleh (Exclude)",
    "🍱 Makan Siang",
    "🌳 Pohon Sejuta Umat",
    "💧 Sumur Pusaka",
    "🌅 Sunset Dermaga Lonthoir",
    "🏨 Balik ke Penginapan",
    "🍽️ Makan Malam",
    "✨ Aktivitas Bebas & Istirahat"
  ],
  day4: [
    "🍽️ Sarapan",
    "🔑 Check-out",
    "⚓ Menuju Pelabuhan (06.00)",
    "🚢 Keberangkatan Kembali (Minggu jam 07.00/08.00)",
    "✅ Selesai"
  ],
    include: [
      "🏠 Penginapan view laut dan gunung (kamar AC)",
      "🍽️ Makan 3x sehari",
      "🚤 Boat ke pulau2",
      "🤿 Alat snorkeling",
      "💧 Air mineral",
      "🍪 Cemilan hopping island",
      "🎟️ Tiket masuk semua destinasi",
      "🧑 Local Guide",
      "📸 Dokumentasi (termasuk underwater) insta 360"
    ],
    exclude: [
      "✈️ Tiket kapal/pesawat dari kota asal ke Banda Neira",
      "🏨 Upgrade ke Hotel Maulana/Villa/Cilubintang",
      "🧴 Kebutuhan Pribadi",
      "🚕 Transportasi/hotel selama di Ambon",
      "🛍️ Oleh-oleh/souvenir"
    ],
    extra: [
      "🥾 Tracking",
      "🤿 Diving/Try Scuba",
      "💆 Massage"
    ],
  },
  {
    id: 2,
    slug: "open-trip-5d3n-pelni-jakarta",
    title: "5D4N Via PELNI",
    route: "Jakarta - Surabaya - Makassar - Bau-Bau - Ambon - Banda Neira",
    price: "Harga berdasarkan Mepo",
    image: "/images/pelni5d.png",
    description: "Pengalaman epik melintasi laut nusantara langsung dari Jakarta (Tanjung Priok) menuju Banda Neira dengan kapal PELNI. Trip ini cocok untuk kalian yang waktunya bebas atau punya waktu libur yang panjang.",
    mepo: [
      "Jakarta (4.700)",
      "Surabaya (4.500)",
      "Makassar (3.900)",
      "Bau-Bau (3.500)",
      "Ambon (3.200)",
      "Banda (2.700)"
    ],
    isMultiMepoSchedule: true,
    schedule: [
      {
        wave: "Jadwal PELNI 5D4N Batch 3 (01-14 October)",
        details: [
          { mpoint: "Start Jakarta", date: "01 (13.00) - 14 Oct (20.00)" },
          { mpoint: "Start Surabaya", date: "02 (19.00) - 13 Oct (15.00)" },
          { mpoint: "Start Makassar", date: "04 (04.00) - 12 Oct (12.00)" },
          { mpoint: "Start Bau-Bau", date: "04 (21.00) - 11 Oct (20.00)" },
          { mpoint: "Start Ambon", date: "06 (01.00) - 10 Oct (19.00)" },
          { mpoint: "Start Banda", date: "06 (09.00) - 10 Oct (11.00)" }
        ]
      },
      {
        wave: "Jadwal PELNI 5D4N Batch 4 (15-28 October)",
        details: [
          { mpoint: "Start Jakarta", date: "15 (13.00) - 28 Oct (20.00)" },
          { mpoint: "Start Surabaya", date: "16 (19.00) - 27 Oct (15.00)" },
          { mpoint: "Start Makassar", date: "18 (04.00) - 26 Oct (12.00)" },
          { mpoint: "Start Bau-Bau", date: "18 (21.00) - 25 Oct (20.00)" },
          { mpoint: "Start Ambon", date: "20 (01.00) - 24 Oct (19.00)" },
          { mpoint: "Start Banda", date: "20 (09.00) - 24 Oct (11.00)" }
        ]
      },
      {
        wave: "Jadwal PELNI 5D4N Batch 5 (29 Oktober - 11 November)",
        details: [
          { mpoint: "Start Jakarta", date: "29 Oct (13.00) - 11 Nov (20.00)" },
          { mpoint: "Start Surabaya", date: "30 Oct (19.00) - 10 Nov (15.00)" },
          { mpoint: "Start Makassar", date: "01 Nov (04.00) - 09 Nov (12.00)" },
          { mpoint: "Start Bau-Bau", date: "01 Nov (21.00) - 08 Nov (20.00)" },
          { mpoint: "Start Ambon", date: "03 Nov (01.00) - 07 Nov (19.00)" },
          { mpoint: "Start Banda", date: "03 Nov (09.00) - 07 Nov (11.00)" }
        ]
      },
      {
        wave: "Jadwal PELNI 5D4N Batch 6 (12-25 November)",
        details: [
          { mpoint: "Start Jakarta", date: "12 (13.00) - 25 Nov (20.00)" },
          { mpoint: "Start Surabaya", date: "13 (19.00) - 24 Nov (15.00)" },
          { mpoint: "Start Makassar", date: "15 (04.00) - 23 Nov (12.00)" },
          { mpoint: "Start Bau-Bau", date: "15 (21.00) - 22 Nov (20.00)" },
          { mpoint: "Start Ambon", date: "17 (01.00) - 21 Nov (19.00)" },
          { mpoint: "Start Banda", date: "17 (09.00) - 21 Nov (11.00)" }
        ]
      },
      {
        wave: "Jadwal Prediksi PELNI 5D4N Batch 7 (26 November - 09 Desember)",
        details: [
          { mpoint: "Start Jakarta", date: "26 Nov (13.00) - 09 Des (20.00)" },
          { mpoint: "Start Surabaya", date: "27 Nov (19.00) - 08 Des (15.00)" },
          { mpoint: "Start Makassar", date: "29 Nov (04.00) - 07 Des (12.00)" },
          { mpoint: "Start Bau-Bau", date: "29 Nov (21.00) - 06 Des (20.00)" },
          { mpoint: "Start Ambon", date: "01 Des (01.00) - 05 Des (19.00)" },
          { mpoint: "Start Banda", date: "01 Des (09.00) - 05 Des (11.00)" }
        ]
      }
    ],
    day1: [
      "⚓ Penjemputan di pelabuhan Banda",
      "🏨 Menuju Penginapan",
      "🔑 Check in",
      "🧳 Beres2",
      "🍽️ Makan siang",
      "🏛️ Rumah Budaya",
      "📜 Rumah pengasingan Sjahrir",
      "🏰 Istana Mini",
      "📜 Rumah Pengasingan Hatta",
      "🏨 Balik ke penginapan",
      "🍽️ Makan malam",
      "🚶 Aktifitas Bebas",
      "💤 istirahat"
    ],
    day2: [
      "🍽️ Sarapan",
      "🚤 Hopping Island",
      "🐬 Pulau Hatta (Dolphine Area)",
      "🤿 Snorkeling",
      "🍽️ makan siang",
      "🏝️ Pulau Sjahrir",
      "⛰️ Tebing Seram",
      "🌳 Perkebunan Pala",
      "🌋 Lava Flow (Snorkeling)",
      "🌅 Sunset Pulau Karaka",
      "🏨 Balik penginapan",
      "🍽️ Makan malam",
      "💤 Istirahat"
    ],
    day3: [
      "🍽️ Sarapan",
      "📜 Sumur genosida",
      "🏰 Benteng Belgica",
      "🛍️ Belanja Oleh2 (exclude)",
      "🍽️ Makan siang",
      "🌳 Pohon sejuta umat",
      "📜 Sumur Pusaka",
      "🌅 Sunset dermaga Lonthoir",
      "🍽️ Makan malam",
      "💤 Istirahat"
    ],
    day4: [
      "🍽️ Sarapan",
      "🌋 Trekking gunung api",
      "🍽️ Makan siang",
      "🚶 Aktifitas Bebas",
      "🍽️ Makan malam",
      "💤 Istirahat"
    ],
    day5: [
      "🍽️ Sarapan",
      "🔑 Check out",
      "⚓ Menuju Pelabuhan",
      "🚢 Keberangkatan/kepulangan (Banda-Ambon-Bau2-Makassar-Surabaya-Jakarta)"
    ],
    include: [
      "🚢 Tiket Pelni Economy PP (Start Point)",
      "🏠 Penginapan 4 Malam (View Laut & Gunung)",
      "🍽️ Makan 12x selama program Banda Neira",
      "🧑‍✈️ Tour Leader (Jakarta-Banda Neira)",
      "💧 Air Mineral selama program",
      "🍪 Cemilan (Saat Hopping Island)",
      "🤿 Alat Snorkeling",
      "🎟️ Tiket Masuk Destinasi",
      "🍽️ Makan 3x/hari selama perjalanan di kapal (Fasilitas PELNI)",
      "🧑 Guide Local",
      "🩹 P3K Standar",
      "📸 Dokumentasi Profesional, Underwater & Drone (Group)"
    ],
    exclude: [
      "🧴 Kebutuhan Pribadi (makanan, minuman dan kebutuhan lainnya di luar fasilitas trip)",
      "💊 Obat-obatan Pribadi",
      "🛍️ Souvenir / oleh-oleh",
      "🥾 Perlengkapan Wajib Tracking Gunung Api (Sepatu, Jaket, Cemilan Pribadi, Air Mineral, Head Lamp)",
      "❌ Biaya lain di luar fasilitas yang tercantum dalam include",
      "💺 Upgrade kelas (PELNI)"
    ],
  },
  // tripData.js (Update Bagian Trip ID 3 - PELNI Ambon dengan Data Terbaru)
{
  id: 3,
  slug: "open-trip-pelni-ambon",
  title: "4D3N Via PELNI",
  route: "Ambon - Banda Neira",
  price: "Mulai dari IDR. 2.999.000",
  image: "/images/pelni4d.png",
  description: "Pilihan perjalanan 4D3N menggunakan Kapal PELNI dengan pilihan Meeting Point (Mepo) di Ambon atau langsung di Banda Neira.",
  mepo: [
    "Ambon (3.599)",
    "Banda Neira (2.999)"
  ],
  schedule: [
    ['Maret', '05 - 08', '1 orang'],
    [' ', '19 - 22', '2 orang'],
    [' ', '26 - 9', '2 orang'],
    ['April', '02 - 05', '2 orang'],
    [' ', '09 - 12', '2 orang'],
    [' ', '16 - 19', '2 orang'],
    [' ', '23 - 26', '2 orang'],
    ['April - Mei', '30 - 03', '2 orang'],
    ['Mei', '14 - 17', '2 orang'],
    [' ', '21 - 24', '2 orang'],
    [' ', '28 - 31', '2 orang'],
    ['September', '03 - 06', '2 orang'],
    [' ', '17 - 20', '2 orang'],
    [' ', '24 - 27', '2 orang'],
    ['Oktober', '01 - 04', '2 orang'],
    [' ', '08 - 11', '2 orang'],
    [' ', '15 - 18', '2 orang'],
    [' ', '22 - 25', '2 orang'],
    ['Oktober - November', '29 - 01', '2 orang'],
    ['November', '05 - 08', '2 orang'],
    [' ', '12 - 15', '2 orang'],
    [' ', '19 - 22', '2 orang'],
    [' ', '26 - 29', '2 orang'],
    ['Desember', '03 - 06', '2 orang'],
    [' ', '10 - 13', '2 orang'],
    [' ', '17 - 20', '2 orang'],
    [' ', '24 - 27', '2 orang'],
  ],
  
  // Dua tipe paket yang bisa dipilih di halaman detail
  subPackages: [
    { 
      type: "Mepo Ambon (4D3N)", 
      price: "IDR 3.599.000", 
      desc: "Include Tiket PELNI PP (Ambon - Banda Neira)",
      day1: [
        "🛬 Penjemputan di Pelabuhan/Bandara Ambon & Persiapan Boarding PELNI",
        "🚢 Keberangkatan dengan Kapal PELNI menuju Banda Neira",
        "⚓ Tiba di Pelabuhan Banda Neira & Check-in Penginapan",
        "🍽️ Welcome Drink & Makan Siang",
        "😴 Istirahat Sejenak",
        "🏝️ Prepare Pulau Sjahrir",
        "⛰️ Tebing Seram",
        "🌲 Pohon Sejuta Umat",
        "🏰 Benteng Hollandia",
        "🌰 Perkebunan Pala",
        "📜 Sumur Pusaka",
        "🏨 Kembali ke Penginapan",
        "🍽️ Makan Malam",
        "🧘 Istirahat"
      ],
      day2: [
        "🍽️ Sarapan",
        "🚤 Hopping Island",
        "🐬 Pulau Nailaka (Dolphine Area)",
        "🍽️ Makan Siang",
        "🤿 Pulau Ay (Snorkeling)",
        "🐠 Lava Flow (Snorkeling)",
        "🌅 Sunset Pulau Karaka",
        "🏨 Kembali ke Penginapan",
        "🍽️ Makan Malam",
        "🧘 Istirahat"
      ],
      day3: [
        "🍽️ Sarapan",
        "🏰 Benteng Belgica",
        "👤 R. Hatta",
        "🏛️ Istana Mini",
        "📜 Sumur Genosida",
        "⛪ Gereja Tua",
        "👤 R. Sjahrir",
        "🏛️ R. Budaya",
        "🍽️ Makan Siang",
        "🛍️ Belanja Souvenir/Oleh-oleh (Exclude)",
        "🏨 Balik Penginapan",
        "🍽️ Makan Malam",
        "🧘 Istirahat"
      ],
      day4: [
        "🍽️ Sarapan",
        "🚪 Check-out Penginapan",
        "🚢 Menuju Pelabuhan & Keberangkatan kembali ke Ambon via PELNI",
        "✅ Trip Selesai"
      ],
      include: [
        "🚢 Tiket Kapal PELNI PP (Ambon - Banda Neira)",
        "🏠 Penginapan View Gunung & Laut (Kamar AC)",
        "🍽️ Makan 3x Sehari",
        "🚤 Boat ke Pulau-pulau",
        "🎟️ Tiket Masuk Destinasi",
        "💧 Air Mineral",
        "🍪 Cemilan Hopping Island",
        "🧑 Local Guide Berpengalaman",
        "🤿 Alat Snorkeling",
        "📸 Dokumentasi"
      ],
      exclude: [
        "🧴 Kebutuhan Pribadi",
        "✈️ Tiket Pesawat / Transportasi dari kota asal ke Ambon",
        "⬆️ Upgrade Kamar di Kapal atau Penginapan di Banda"
      ]
    },
    { 
      type: "Mepo Banda (4D3N)", 
      price: "IDR 2.999.000", 
      desc: "Exclude Tiket PELNI (Meeting Point di Banda Neira)",
      day1: [
        "🛬 Penjemputan di Pelabuhan/Bandara Banda Neira",
        "🗝️ Check-in Penginapan",
        "🍽️ Welcome Drink/Makan Siang",
        "😴 Istirahat Sejenak",
        "🏝️ Prepare Pulau Sjahrir",
        "⛰️ Tebing Seram",
        "🌲 Pohon Sejuta Umat",
        "🏰 Benteng Hollandia",
        "🌰 Perkebunan Pala",
        "📜 Sumur Pusaka",
        "🏨 Kembali ke Penginapan",
        "🍽️ Makan Malam",
        "🧘 Istirahat"
      ],
      day2: [
        "🍽️ Sarapan",
        "🚤 Hopping Island",
        "🐬 Pulau Nailaka (Dolphine Area)",
        "🍽️ Makan Siang",
        "🤿 Pulau Ay (Snorkeling)",
        "🐠 Lava Flow (Snorkeling)",
        "🌅 Sunset Pulau Karaka",
        "🏨 Kembali ke Penginapan",
        "🍽️ Makan Malam",
        "🧘 Istirahat"
      ],
      day3: [
        "🍽️ Sarapan",
        "🏰 Benteng Belgica",
        "👤 R. Hatta",
        "🏛️ Istana Mini",
        "📜 Sumur Genosida",
        "⛪ Gereja Tua",
        "👤 R. Sjahrir",
        "🏛️ R. Budaya",
        "🍽️ Makan Siang",
        "🛍️ Belanja Souvenir/Oleh-oleh (Exclude)",
        "🏨 Balik Penginapan",
        "🍽️ Makan Malam",
        "🧘 Istirahat"
      ],
      day4: [
        "🍽️ Sarapan",
        "🚪 Check-out Penginapan",
        "🚢 Menuju Pelabuhan Banda Neira",
        "✅ Trip Selesai"
      ],
      include: [
        "🏠 Penginapan View Gunung & Laut (Kamar AC)",
        "🍽️ Makan 3x Sehari",
        "🚤 Boat ke Pulau-pulau",
        "🎟️ Tiket Masuk Destinasi",
        "💧 Air Mineral",
        "🍪 Cemilan Hopping Island",
        "🧑 Local Guide Berpengalaman",
        "🤿 Alat Snorkeling",
        "📸 Dokumentasi"
      ],
      exclude: [
        "✈️🚢 Tiket Kapal PELNI, Fast Boat, atau Pesawat ke Banda Neira",
        "🧴 Kebutuhan Pribadi",
        "⬆️ Upgrade Kamar Hotel / Penginapan di Banda"
      ]
    }
  ],
  // ... schedule sama seperti trip lainnya
  extra: ["🤿 Diving / Try Scuba", "🥾 Tracking", "💆 Massage"]
}
];